import React, {useState, useEffect} from 'react';

const CountdownTimer = ({dateCreate, countdownStartFromMinutes}) => {
    const [timeLeft, setTimeLeft] = useState({
        minutes: 0,
        seconds: 0,
    });
    const [timerActive, setTimerActive] = useState(false);

    useEffect(() => {
        if (!timerActive) return;

        const interval = setInterval(() => {
            setTimeLeft((prevTimeLeft) => {
                let {minutes, seconds} = prevTimeLeft;

                if (seconds === 0) {
                    if (minutes === 0) {
                        clearInterval(interval);
                        setTimerActive(false);
                        return {minutes: 0, seconds: 0};
                    }

                    // Decrement minutes and reset seconds to 59
                    minutes -= 1;
                    seconds = 59;
                } else {
                    // Decrement seconds
                    seconds -= 1;
                }

                return {minutes, seconds};
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [timerActive]);

    useEffect(() => {
        const currentDate = new Date();
        // const targetDate = new Date(dateCreate);
        const targetDate = new Date(dateCreate.replace(' ', 'T'));
        const difference = currentDate - targetDate;

        const minutes = Math.floor((difference / 1000) / 60);
        const seconds = (difference / 1000) % 60;

        if (isNaN(targetDate)) {
            console.error("Invalid dateCreate format:", dateCreate);
            return;
        }

        if (minutes === 0) {
            setTimeLeft({
                // minutes: countdownStartFromMinutes === 10 ? 9 : 14,
                minutes: countdownStartFromMinutes === 3 ? 2 : 4,
                seconds: 60 - Math.floor(seconds),
            })
            setTimerActive(true);
        } else if (minutes > 0 && minutes <= countdownStartFromMinutes) {
            if (minutes === countdownStartFromMinutes) {
                setTimeLeft({
                    minutes: 0,
                    seconds: 0,
                })
            } else {
                setTimeLeft({
                    minutes: countdownStartFromMinutes - 1 - minutes,
                    seconds: seconds === 60 ? 59 : 60 - Math.floor(seconds),
                })
                setTimerActive(true);
            }
        }
    }, []);

    return (
        <>
            {timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}:
            {timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}
        </>
    );
};

export default CountdownTimer;
